import moment from "moment";
import React, {useContext, useEffect, useRef, useState} from "react";
import "./ModestoChat.scss";
import {MicOff as MicOffIcon, Mic as MicIcon} from "@mui/icons-material";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {Button, IconButton} from "@mui/material";
import {authContext} from "../Context/Authentication/authContext";
import axios from "axios";
import classNames from "classnames";
import bg5 from "../assets/chatBg_5.png";
import bg6 from "../assets/chatBg_6.png";
import robo from "../assets/chatBg_9.png";

import img from "../assets/ai7.png";

import Slider from "react-slick";
import {useNavigate} from "react-router-dom";
import {getTopCities} from '../Helpers/helpers'
import {getInitialOptions} from '../util'
// @ts-ignore
import {v4 as uuidv4} from 'uuid';
import {stateData} from "./stateData";
import {otherBaseURL, chatURL} from '../config';

const containsKeywords = (inputString: string) => {
  const keywords = ['mortgage rate', 'mortgagerate'];
  const lowerCaseInput = inputString.toLowerCase();

  for (const keyword of keywords) {
    if (lowerCaseInput.includes(keyword.toLowerCase())) {
      return true;
    }
  }

  return false;
}

const extractInformation = (inputString: string) => {
  let percentage = 0;
  const regex = /-?\d+(\.\d+)?/g;
  let numericValues = inputString.match(regex);
  // @ts-ignore
  numericValues = numericValues ? numericValues.map(Number) : [];
  if (numericValues && numericValues.length > 0) {
    // @ts-ignore
    percentage = numericValues[0];
  }
  let state = null
  let city = null
  if (inputString.toLowerCase().includes('decrease')) {
    if (percentage > 0) {
      percentage = percentage - (2 * percentage)
    }
  }

  Object.entries(stateData).forEach(([key, value]) => {
    if (inputString.toLowerCase().includes(key.toLowerCase())) {
      state = key
      const searchedItem = value.find((v: string) => inputString.toLowerCase().includes(v.toLowerCase()))
      if (searchedItem) city = searchedItem
    }
  });

  return {
    percentage,
    city,
    state
  }
}

const carouselSettings = {
  dots: false,
  infinite: false,
  slickPlay: true,
  //   autoplay: true,
  //   speed: 500,
  //   autoplaySpeed: 10000,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  //   pauseOnHover: false,
};

interface ChatProps {
  selectedState: string;
  open: boolean;
  handleClose: any;
}


const appId = "d405b2a8-7be6-43e8-9c45-4efc06413582";

const bgImages = [
  {bg: bg6, showText: true},
  {bg: bg5, showText: false},
];

const cities = [
  { name: "Manteca", route: "/geo/manteca-ca" },
  { name: "Modesto", route: "/geo" },
  { name: "Elk Grove", route: "/geo/elk-grove-ca" },
  { name: "Roseville", route: "/geo/roseville-ca" },
];

const displayResponse = (text: any) => {
  const input = text.replaceAll('\n',' ')
  let sentences = input.split(/(?<!\d\.)(?<!\w\.\w.)(?<![A-Z][a-z]\.)(?<=\.|\?)\s/g);

  if (sentences.length > 0) {
    return (
      <div>
        {sentences.map((item: any, index: number) => (
          <div>
            <span key={index}>{item}</span>
            {sentences.length - 1 !== index && (
              <>
                <br/>
                <br/>
              </>
            )}
          </div>
        ))}
      </div>
    );
  }

  return <p>{text}</p>;
};

const ModestoChat = ({
                       open,
                       handleClose,
                       selectedState,
                     }: ChatProps): React.ReactElement => {
  const navigate = useNavigate();
  const {state, dispatch}: any = useContext(authContext);
  const messagesEndRef: any = useRef(null);
  const textAreaRef: any = useRef(null);
  const [marqueeSuggestions, setMarqueeSuggestions] = useState([]);
  const [text, setText] = useState("");
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const [showChat, setShowChat] = useState(false);

  const [chatData, setChatData]: any = useState([]);
  const [imageData, setImageData]: any = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const currentState = state.filters.state

  useEffect(() => {
    if (text !== "") setText("");
  }, [selectedState]);

  useEffect(() => {
    setText(transcript);
  }, [transcript]);

  useEffect(() => {
    scrollToBottom();
  }, [chatData, imageData]);

  useEffect(() => {
    topCities()
  }, [state.filters?.state])

  const topCities = async () => {
    const topCitiesInfo = await getTopCities(state.filters?.state)
    let suggestionText: any = []
    const stateTopCities: any = []
    const predefinedCities = ['Manteca', 'Modesto']
    const predefinedUrls = {
      Manteca: '/geo/manteca-ca',
      Modesto: '/geo'
    }
    topCitiesInfo.forEach((city: string, index: number) => {
      if (predefinedCities.includes(city))
        // @ts-ignore
        stateTopCities.push({name: city, route: predefinedUrls[city]})
      else
        stateTopCities.push({name: city})


      if (index === 0) {
        suggestionText = [...suggestionText, ...getInitialOptions(city)]
      }
    })
    suggestionText = ['What places to invest in my Proximity?', ...suggestionText,]

    setCities(stateTopCities)
    setMarqueeSuggestions(suggestionText)
  }

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({behavior: "smooth"});
  };

  const handleTextChange = (e: any) => {
    setText(e.target.value);
  };

  const handleSend = async () => {
    setShowChat(true);
    if (text?.trim() === "") return;
    resetTranscript();
    setIsLoading(true);
    const qry = text;
    setText("");
    let data;
    if (selectedState === "chat") {
      data = [
        ...chatData,
        {
          name: state?.user?.username,
          message: qry,
          time: `${moment().format("h:mmA")}, Today`,
          type: "me",
        },
      ];
      setChatData(data);
    } else {
      data = [
        ...imageData,
        {
          name: state?.user?.username,
          message: qry,
          time: `${moment().format("h:mmA")}, Today`,
          type: "me",
        },
      ];
      setImageData(data);
    }

    let respData = ''
    if (containsKeywords(qry)) {
      const info = extractInformation(qry)
      if (info?.percentage && info?.city && info?.state) {
        try {
          const response = await axios.get(`${otherBaseURL}realestateTrigger/${info?.state}/Mortgage_US/${info?.percentage}/${info?.city}/12_months_lag/City`)
          const overall = response?.data?.metrics_change_dict
          respData = "Current Mortgage Rate as of 2023-Q2 is '6.69'. \n "+info?.percentage + '% Change in the Mortgage Rate has the following projected impact after 12 months lag. \nPrice Per Sq. Ft is '
            + overall.ppsf + '%.\nHome Sales is ' + overall.hs + '%.\nDays on Market is ' + overall.dom
            + '%.'
          dispatch({
            type: 'APPLY_FILTER',
            payload: {
              ...state.filters,
              selectedType: 'whatIfAnalysis',
              state: info?.state,
              whatIfSelectedCity: {name: info?.city},
              whatIfPercentage: info?.percentage,
              whatIfSubmit: true,
              changeCity: true,
              hitSubmit: true,
            },
          });
        } catch (e) {
          console.error(e)
          respData = 'Could not fetch details for requested query.'
        }
      } else {
        respData = 'Could not fetch details for requested query.'
      }
    } else {
      const url = `${chatURL}realEstateApiParam?question=${qry}&state=${currentState}`;

      const res = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      respData = res?.data
    }
    if (respData) {
      const result = [
        ...data,
        {
          name: "Linda",
          message: displayResponse(respData),
          time: `${moment().format("h:mmA")}, Today`,
          type: "you",
        },
      ];
      // setTimeout(() => {
      if (selectedState === "chat") {
        setChatData(result);
      } else {
        setImageData(result);
      }

      // }, 1000);
    }
    setIsLoading(false);
  };

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  return open ? (
    <div className="modestoChat-main">
      <div className="modestoChat-main__header">
        <div className="modestoChat-main__header__text">Slate Converse</div>
        <IconButton
          onClick={() => {
            handleClose();
          }}
        >
          <KeyboardArrowRightIcon className="modestoChat-main__header__icon"/>
        </IconButton>
      </div>
      <div className="modestoChat-main__content">
        {!showChat && (
          <Slider {...carouselSettings}>
            {bgImages?.map((item: any, i: number) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  height: "100%",
                  width: "100%",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    backgroundImage: `url(${item.bg})`,
                    flex: 1,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundColor: "grey",
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    top: 0,
                  }}
                >
                  {item.showText ? (
                    <div
                      style={{
                        height: "auto",
                        color: "#fff",
                        fontSize: "1.6rem",
                        textAlign: "center",
                        fontWeight: 600,
                        padding: "1.5rem",
                        background: "rgb(0,0,0,0.6)",
                        minHeight: "calc(100% - 55px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          animation: "openFromTop 4s ease",
                          marginTop: "-200px",
                        }}
                      >
                        Good Morning, Senthil!
                      </div>
                      {/* <div style={{ marginTop: "0.2rem" }}></div> */}
                      <div
                        style={{
                          marginTop: "2rem",
                          fontSize: "1.2rem",
                          //   fontWeight: "normal",
                          color: "#f7b047",
                          animation: "openFromBottom 4s ease",
                        }}
                      >
                        Here's something you might like
                      </div>
                      <div
                        style={{
                          marginTop: "1rem",
                          fontSize: "1rem",
                          fontWeight: 400,
                          color: "#fff",
                          animation: "openFromBottom 4s ease",
                        }}
                      >
                        Places of interest for Real estate investment nearby
                      </div>
                      <div
                        className={classNames({
                          //   "scroll-text": true,
                        })}
                        style={{
                          marginTop: "3rem",
                          flexDirection: "column",
                          alignItems: "center",
                          display: !item.showText ? "none" : "flex",
                          marginBottom: "1rem",
                          animation: "openFromBottom 4s ease",
                        }}
                      >
                        {cities.map((city: any) => (
                          <div
                            style={{
                              fontSize: "1rem",
                              color: "#f7b047",
                              //   backgroundColor: "#f7b047",

                              borderRadius: "4px",
                              cursor: "pointer",
                              marginBottom: "1rem",
                              width: "6rem",
                              whiteSpace: "nowrap",
                              //   marginRight: "1rem",
                            }}
                            onClick={() => {
                              navigate(city?.route);
                              // setText(city);
                              // textAreaRef.current.focus();
                            }}
                          >
                            {city?.name}
                          </div>
                        ))}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                          padding: "0.8rem",
                          backgroundColor: "transparent",
                          textAlign: "start",
                          borderRadius: "10px",
                          alignItems: "center",
                          // margin: "2rem 2.5rem",
                          position: "absolute",
                          bottom: "155px",
                          // width: "90%",
                          animation: "openFromBottom 4s ease forwards",
                          // transition: "all 2s ease",
                        }}
                        className="modestoChat-main__content__card"
                      >
                        <div
                          style={{
                            marginRight: "1.5rem",
                          }}
                        >
                          <img
                            style={{height: "4.5rem", width: "7.5rem"}}
                            src={robo}
                          ></img>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            // justifyContent: "center",
                            width: "100%",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "0.8rem",
                              cursor: "pointer",
                              width: "fit-content",
                              marginTop: "2.5rem",
                              fontWeight: "normal",
                            }}
                            onClick={() => navigate("/")}
                          >
                            Take me there!
                          </div>
                          {/* <div
                            style={{
                              fontSize: "0.7rem",
                              fontWeight: "normal",
                            }}
                          >
                            Set goals and track your progress in the app. Lets
                            go.
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ) : (
                    !item.showText && (
                      <div
                        style={{
                          height: "auto",
                          color: "#fff",
                          fontSize: "1.6rem",
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "1rem",
                          background: "rgb(0,0,0,0.6)",
                          minHeight: "100%",
                          display: !item.showText ? "flex" : "block",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            margin: "-200px 0 5rem 0",
                            animation: "openFromBottom 4s ease",
                          }}
                        >
                          Ways I can help you
                        </div>
                        <div style={{fontSize: "1rem"}}>
                          <div style={{marginTop: "1rem", color: "#f7b047"}}>
                            Predict the future!!
                          </div>
                          <div style={{marginTop: "1rem", color: "#f7b047"}}>
                            Analyse economic trends
                          </div>
                          <div style={{marginTop: "1rem", color: "#f7b047"}}>
                            Suggest places to invest
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            padding: "0.8rem",
                            backgroundColor: "transparent",
                            textAlign: "start",
                            borderRadius: "10px",
                            alignItems: "center",
                            // margin: "2rem 2.5rem",
                            position: "absolute",
                            bottom: "155px",
                            // width: "90%",
                            animation: "openFromBottom 4s ease forwards",
                          }}
                          className="modestoChat-main__content__card"
                        >
                          <div
                            style={{
                              marginRight: "1.5rem",
                            }}
                          >
                            <img
                              style={{height: "4.5rem", width: "7.5rem"}}
                              src={robo}
                            ></img>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              // justifyContent: "center",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            <Button
                              variant="contained"
                              style={{
                                fontSize: "0.8rem",
                                // cursor: "pointer",
                                padding: "0.2rem 1rem",
                                backgroundColor: "#1976d2",
                                width: "fit-content",
                                marginTop: "2rem",
                              }}
                              // onClick={() => navigate("/")}
                            >
                              Show me how
                            </Button>
                            {/* <div
                            style={{
                              fontSize: "0.7rem",
                              fontWeight: "normal",
                            }}
                          >
                            Set goals and track your progress in the app. Lets
                            go.
                          </div> */}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            ))}
          </Slider>
        )}
        {showChat && (
          <ul
            id="chat"
            style={{
              backgroundColor: chatData?.length
                ? "rgba(255, 255, 255, 0.7)"
                : "rgba(255, 255, 255, 0.4)",
            }}
          >
            {(selectedState === "chat" ? chatData : imageData).map(
              (item: any, i: number) => (
                <li className={item.type} key={i}>
                  <div className="entete">
                    <span className="status green"></span>
                    {item.type === "you" ? (
                      <>
                        <span className="text name">{item.name}</span>
                        <span className="text time">{item.time}</span>
                      </>
                    ) : (
                      <>
                        <span className="text time">{item.time}</span>
                        <span className="text name">{item.name}</span>
                      </>
                    )}
                  </div>
                  <div className="triangle"></div>
                  {selectedState === "chat" ? (
                    <div className="message"> {item.message}</div>
                  ) : (
                    <div
                      className={
                        item.type === "you" ? "message img-message" : "message"
                      }
                    >
                      {" "}
                      {item.type === "you" ? (
                        <img src={item.message} width="100%"/>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.message,
                          }}
                        ></div>
                        // item.message
                      )}
                    </div>
                  )}
                </li>
              )
            )}
            {isLoading && (
              <li className="you">
                <div className="entete">
                  <span className="text name">Linda</span>
                  <span className="text time">{`${moment().format(
                    "h:mmA"
                  )}, Today`}</span>
                </div>
                <div className="triangle"></div>
                <div className="messageTyping">
                  <span className="dot dot1"></span>
                  <span className="dot dot2"></span>
                  <span className="dot dot3"></span>
                </div>
              </li>
            )}

            <li ref={messagesEndRef}></li>
            <div
              className={classNames({
                "suggestion-list": true,
                "scroll-text": true,
                "z-index-zero": selectedState === "image",
              })}
            >
              {marqueeSuggestions.map((item, index) => (
                <span
                  className="suggestion"
                  onClick={() => {
                    setText(item);
                    textAreaRef.current.focus();
                  }}
                  key={index}
                >
                  {item}
                </span>
              ))}
            </div>
          </ul>
        )}
        <footer className="modestoChat-main__footer">
          <textarea
            ref={textAreaRef}
            className={showChat ? "textarea" : "textarea noBg"}
            placeholder="Interact with me"
            value={text}
            onChange={(e: any) => {
              handleTextChange(e);
            }}
            onKeyDown={(e: any) => {
              if (e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                handleSend();
              }
            }}
          ></textarea>
          {listening ? (
            <MicOffIcon
              className="speechIcon"
              onClick={() => SpeechRecognition.stopListening()}
            />
          ) : (
            <MicIcon
              className="speechIcon"
              onClick={() =>
                SpeechRecognition.startListening({continuous: true})
              }
            />
          )}
          <a onClick={() => handleSend()}>Send</a>
          {showChat && (
            <KeyboardArrowLeftIcon
              onClick={() => setShowChat(false)}
              style={{cursor: "pointer", fontSize: "1.2rem"}}
            />
          )}
        </footer>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ModestoChat;
